import { rotasAdministrativo } from './administrativo/index'
import { rotasAtendimento } from './atendimento/index'
import { rotasContatos } from './contato/index'

const rotas = [rotasAdministrativo, rotasAtendimento, rotasContatos]
export default rotas
